{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -117.20023288064766,
              32.51888012066348
            ],
            [
              -115.39570052640838,
              26.465180532380487
            ],
            [
              -105.14011783784193,
              18.127385372920088
            ],
            [
              -92.37164576052291,
              13.960759196172603
            ],
            [
              -91.76785136529452,
              15.98631706638838
            ],
            [
              -90.43993445706752,
              16.360767895707596
            ],
            [
              -91.22738005469935,
              17.56138591949201
            ],
            [
              -89.21214773332167,
              17.89756643969919
            ],
            [
              -88.2250140795741,
              18.578920626210362
            ],
            [
              -87.8424350124321,
              18.124745998402503
            ],
            [
              -86.04555275833397,
              21.37341071869035
            ],
            [
              -97.01147571537908,
              25.91239900523246
            ],
            [
              -101.60573790116567,
              29.869360329167932
            ],
            [
              -103.75538090804312,
              29.262392182463714
            ],
            [
              -106.43739417958147,
              31.649990582585048
            ],
            [
              -110.93088716507529,
              31.31454083351379
            ],
            [
              -114.68796940427566,
              32.73559062432459
            ],
            [
              -117.20023288064766,
              32.51888012066348
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}